import React from 'react';
import { alpha, IconButton, Tooltip } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { IManagePortalButton } from './interfaces';

export const ManagePortalButton: React.FC<IManagePortalButton> = ({
  href,
  label,
}): JSX.Element => {
  const { t } = useTranslation();
  const buttonLabel = label || t('competitions:portal.details.manageButton');

  return (
    <Tooltip title={buttonLabel}>
      <IconButton
        component={Link}
        to={href}
        aria-label={buttonLabel}
        sx={{
          position: 'absolute',
          top: 10,
          right: 10,
          bgcolor: alpha('#FFF', 0.85),
          boxShadow: 1,
          zIndex: 1,
          '&:hover': {
            bgcolor: alpha('#FFF', 0.95),
          },
        }}
      >
        <SettingsIcon />
      </IconButton>
    </Tooltip>
  );
};
